<script setup lang="ts">
import { TooltipProvider, Tooltip, TooltipTrigger, TooltipContent } from '@/components/tooltip'

const tooltipContent = 'Goalbook discourages entering student personally identifiable information.'
</script>
<template>
  <TooltipProvider :delay-duration="0">
    <Tooltip>
      <TooltipTrigger as-child>
        <button
          type="button"
          class="material-icons-round text-primary-400 cursor-pointer"
          aria-label="Student PII guidance"
          >help</button
        >
      </TooltipTrigger>
      <TooltipContent class="tooltip-style tooltip-style-z">
        {{ tooltipContent }}
      </TooltipContent>
    </Tooltip>
  </TooltipProvider>
</template>
